import { useEffect, useState } from "react";

/**
 * Hook to get the value of a specific cookie
 * @param {*} name  Name of the cookie
 * @returns Value of the cookie
 */
function useCookie(name) {
  const [cookieValue, setCookieValue] = useState(null);

  useEffect(() => {
    const cookies = document.cookie.split(";");
    for (let i = cookies.length - 1; i >= 0; i--) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        setCookieValue(decodeURIComponent(cookie.substring(name.length + 1)));
        break;
      }
    }
  }, [name]);

  return cookieValue;
}

export default useCookie;
